import { getToken, getUserType, getType, getAccessToken, getLoginSource } from '@/utils/auth'
import { ssoLogin, ssoLogout, ncnpLogout, checkToken, ncnpAuthCallback } from '@/api/index'
import { corpAuthAlert } from '@/utils/index'
import website from '@/config/website'

const state = {
    token: getToken(), //userToken 判断用户是否登录的
    userType: getUserType(), //是否有控制台权限 1有2没有
    type: getType(), //1个人2企业
    account: "", //账号
    accessToken: getAccessToken(), //accessToken 系统内部接口调用使用的
    loginSource: getLoginSource(), //登录来源
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
        localStorage.setItem("userToken", token);
    },
    SET_USER_TYPE: (state, userType) => {
        state.userType = userType
        localStorage.setItem('userType', userType)
    },
    SET_TYPE: (state, type) => {
        state.type = type
        localStorage.setItem('type', type)
    },
    SET_ACCOUNT: (state, account) => {
        state.account = account
        localStorage.setItem('account', account)
    },
    SET_ACCESS_TOKEN: (state, accessToken) => {
        state.accessToken = accessToken
        localStorage.setItem('accessToken', accessToken)
    },
    SET_LOGIN_SOURCE: (state, loginSource) => {
        state.loginSource = loginSource
        localStorage.setItem('loginSource', loginSource)
    },
}

const actions = {
    // 单点登录处理
    ssoLogin({ commit }, code) {
        return new Promise((resolve, reject) => {
            // 这里需要调用后端接口获取token
            // 示例：假设接口返回 { token: 'xxx' }
            ssoLogin({ code })
                .then(response => {
                    console.log(response.data);
                    
                    // 判断response.data不是空对象或者null或者undefined
                    if (response.data && Object.keys(response.data).length > 0) {
                        const { userToken, userType, type } = response.data;
                        commit("SET_TOKEN", userToken);
                        commit("SET_USER_TYPE", userType);
                        commit("SET_TYPE", type);
                        if (response.data.user) {
                            commit("SET_ACCOUNT", response.data.user.account);
                        }
                        if (response.data.token) {
                            commit("SET_ACCESS_TOKEN", response.data.token.accessToken);
                        }
                        resolve();
                    } else {
                        // 当企业账号未认证时，弹出提示框
                        corpAuthAlert();
                        reject(new Error('企业账号未认证'));
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // 国家平台统一认证回调处理
    ncnpLogin({ commit }, payload) {
        return new Promise((resolve, reject) => {
            ncnpAuthCallback(payload)
                .then(response => {
                    if (response.data && Object.keys(response.data).length > 0) {
                        const { userToken, userType, type, loginSource } = response.data;
                        commit("SET_TOKEN", userToken);
                        commit("SET_USER_TYPE", userType);
                        commit("SET_TYPE", type);
                        commit("SET_LOGIN_SOURCE", loginSource || "NCNP");
                        if (response.data.user) {
                            commit("SET_ACCOUNT", response.data.user.account);
                        }
                        if (response.data.token) {
                            commit("SET_ACCESS_TOKEN", response.data.token.accessToken);
                        }
                        resolve(response.data);
                    } else {
                        reject(new Error('国家平台登录失败'));
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    async ssoLogout({ commit }) {
        return new Promise((resolve, reject) => {
            ssoLogout({ userToken: state.token })
                .then(response => {
                    commit('SET_TOKEN', '')
                    commit('SET_USER_TYPE', '')
                    commit('SET_TYPE', '')
                    commit('SET_ACCESS_TOKEN', '')
                    commit('SET_LOGIN_SOURCE', '')
                    resolve()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // 国家平台会话登出（撤销 NCNP access_token + 清理后端 Redis 会话）
    async ncnpLogout() {
        return ncnpLogout({ userToken: state.token })
    },

    // 登出：按登录来源路由到对应的后端撤销接口
    async logout({ state, commit, dispatch }, isValid) {
        try {
            if (isValid) {
                if (state.loginSource === 'NCNP') {
                    await dispatch('ncnpLogout');
                } else {
                    await dispatch('ssoLogout');
                }
            }
            // 清除本地状态
            commit('SET_TOKEN', '')
            commit('SET_USER_TYPE', '')
            commit('SET_TYPE', '')
            commit('SET_ACCESS_TOKEN', '')
            commit('SET_LOGIN_SOURCE', '')
        } catch (error) {
            console.error('Logout failed:', error);
            throw error;
        }
    },

    // 判断token是否有效
    async checkTokenValidity({ state, commit }) {
        if (!state.token) {
            return { isValid: false, message: 'Token不存在' };
        }

        try {
            const response = await checkToken({ userToken: getToken() });
            // 假设接口返回 { isValid: true/false }
            if (response.code === 200) {
                return { isValid: true, message: 'Token是有效的' };
            } else {
                // 清除本地状态
                commit('SET_TOKEN', '')
                commit('SET_USER_TYPE', '')
                commit('SET_TYPE', '')
                commit('SET_ACCESS_TOKEN', '')
                commit('SET_LOGIN_SOURCE', '')
                return { isValid: false, message: 'Token是无效' };
            }
        } catch (error) {
            console.error('Error checking token validity:', error);
            return { isValid: false, message: 'Error checking token validity' };
        }
    },

    // 清除用户信息
    clearUserInfo({ commit }) {
        commit('SET_TOKEN', '')
        commit('SET_USER_TYPE', '')
        commit('SET_TYPE', '')
        commit('SET_ACCOUNT', '')
        commit('SET_ACCESS_TOKEN', '')
        commit('SET_LOGIN_SOURCE', '')
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
